import styled from '@emotion/styled';
import Icon from '@icon/Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const ArrowLeft = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 16 16" {...rest}>
      <path
        d="M13.3333 8H2.66658"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66675 4L2.66675 8L6.66675 12"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default ArrowLeft;
